var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcomingSessionTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.75,
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2247 22.7091L20.4164 21.0424V17.2674C20.4164 16.9341 20.1497 16.6674 19.8164 16.6674H19.7664C19.4331 16.6674 19.1664 16.9341 19.1664 17.2674V21.2008C19.1664 21.4924 19.3164 21.7674 19.5747 21.9174L22.6164 23.7424C22.8997 23.9091 23.2664 23.8258 23.4331 23.5424C23.6081 23.2508 23.5164 22.8758 23.2247 22.7091ZM27.6497 14.1758L25.0831 12.0424C24.7331 11.7508 24.2081 11.7924 23.9081 12.1508C23.6164 12.5008 23.6664 13.0258 24.0164 13.3258L26.5747 15.4591C26.9247 15.7508 27.4497 15.7091 27.7497 15.3508C28.0497 15.0008 27.9997 14.4758 27.6497 14.1758ZM13.4164 15.4591L15.9747 13.3258C16.3331 13.0258 16.3831 12.5008 16.0831 12.1508C15.7914 11.7924 15.2664 11.7508 14.9164 12.0424L12.3497 14.1758C11.9997 14.4758 11.9497 15.0008 12.2497 15.3508C12.5414 15.7091 13.0664 15.7508 13.4164 15.4591ZM19.9997 13.3341C15.8581 13.3341 12.4997 16.6924 12.4997 20.8341C12.4997 24.9758 15.8581 28.3341 19.9997 28.3341C24.1414 28.3341 27.4997 24.9758 27.4997 20.8341C27.4997 16.6924 24.1414 13.3341 19.9997 13.3341ZM19.9997 26.6674C16.7831 26.6674 14.1664 24.0508 14.1664 20.8341C14.1664 17.6174 16.7831 15.0008 19.9997 15.0008C23.2164 15.0008 25.8331 17.6174 25.8331 20.8341C25.8331 24.0508 23.2164 26.6674 19.9997 26.6674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingSessionTime);
export default __webpack_public_path__ + "static/media/upcomingSessionTime.8d98d6d8bf49b8740f42016ace5ad37b.svg";
export { ForwardRef as ReactComponent };